// src/utils/exportFunctions.js

import * as con from "../GlobalConstants";
import { translateParameter } from "./translateFunctions";
import { filterObject } from "../GlobalFunctions";

// =========================
// Base
// =========================
const baseExport = (vals, columns) =>
  Object.values(vals).map((ob) =>
    Object.fromEntries(columns.map((col) => [col[con.NAME], ob[col[con.ID]]]))
  );


const exportExposures = (vals) =>
  baseExport(vals, con.EXPOSURES_EXPORT_COLUMNS);

const exportCoverageFWD = (vals) => {
  const translated = Object.fromEntries(
    Object.entries(vals).map(([k, ob]) => [
      k,
      { ...ob, [con.COVERAGE_TYPE]: translateParameter(ob[con.COVERAGE_TYPE]) },
    ])
  );
  return baseExport(translated, con.COVERAGES_FWD_EXPORT_COLUMNS);
};

const exportCoverageSPOT = (vals, clientType = con.IMPORTER) => {
  const columns =
    clientType === con.IMPORTER
      ? con.COVERAGES_SPOT_EXPORT_COLUMNS_IMPORTER
      : con.COVERAGES_SPOT_EXPORT_COLUMNS_EXPORTER;
  return baseExport(vals, columns);
};

const exportCoverageOption = (vals) => {
  const translated = Object.fromEntries(
    Object.entries(vals).map(([k, ob]) => [
      k,
      { ...ob, [con.COVERAGE_TYPE]: translateParameter(ob[con.COVERAGE_TYPE]) },
    ])
  );
  return baseExport(translated, con.COVERAGES_OPTION_EXPORT_COLUMNS);
};

const exportAccounts = (vals, clientType = con.IMPORTER) => {
  const filtered =
    clientType === con.EXPORTER
      ? filterObject(vals, (ob) => ob[con.ACCOUNT_TYPE] === con.NATURAL_COVERAGE)
      : vals;

  const translated = Object.fromEntries(
    Object.entries(filtered).map(([k, ob]) => [
      k,
      { ...ob, [con.ACCOUNT_TYPE]: translateParameter(ob[con.ACCOUNT_TYPE]) },
    ])
  );
  return baseExport(translated, con.ACCOUNTS_EXPORT_COLUMNS);
};

// =========================
// Dispatcher
// =========================
const EXPORT_MAP = {
  [con.EXPOSURES]:        (vals, ct) => exportExposures(vals),
  [con.COVERAGES_FWD]:    (vals, ct) => exportCoverageFWD(vals),
  [con.COVERAGES_SPOT]:   (vals, ct) => exportCoverageSPOT(vals, ct),
  [con.COVERAGES_OPTION]: (vals, ct) => exportCoverageOption(vals),
  [con.ACCOUNTS]:         (vals, ct) => exportAccounts(vals, ct),
};

export const exportTransactionsByType = (transactionType, vals, clientType = con.IMPORTER) => {
  const exportFn = EXPORT_MAP[transactionType];
  if (!exportFn) {
    console.warn(`No export defined for transaction type: ${transactionType}`);
    return [];
  }
  return exportFn(vals, clientType);
};